import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApi } from '../use-api';
import { api, BookDetail } from '../api';
import { Layout, Loading, ErrorBox } from '../components/Layout';

function duration(sec: number | null) {
  if (!sec) return null;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function Book() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data, error, loading } = useApi<BookDetail>(() => api.book(id!), [id]);

  return (
    <Layout>
      {loading && <Loading />}
      {error && <ErrorBox message={error} />}
      {data && (
        <>
          <Link to={`/grade/${data.grade.id}`} className="text-sm text-sky-700 hover:underline">
            ← {data.grade.name} / {data.subject.name}
          </Link>
          <h1 className="text-2xl font-semibold text-slate-900 mt-2">{data.title}</h1>
          <p className="text-sm text-slate-500 mb-4">
            {t('book.videos', { count: data.videos.length })}
          </p>

          {/* "Download all (SD)" is Phase 2 (spec §9) — deliberately not here. */}

          <ol className="divide-y divide-slate-200 rounded-xl bg-white border border-slate-200">
            {data.videos.map((v) => (
              <li key={v.id}>
                <Link
                  to={`/watch/${v.id}`}
                  className="flex items-center gap-3 p-4 hover:bg-slate-50 transition"
                >
                  <span className="w-8 shrink-0 text-sm text-slate-400 tabular-nums">
                    {v.order}
                  </span>
                  <span className="flex-1 text-slate-900">{v.title}</span>
                  {duration(v.durationSec) && (
                    <span className="text-sm text-slate-400 tabular-nums" dir="ltr">
                      {duration(v.durationSec)}
                    </span>
                  )}
                  <span className="text-xs text-slate-400" dir="ltr">
                    {v.languages.join(' · ')}
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </>
      )}
    </Layout>
  );
}
